import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { AppModuleGlobalShared } from '../../../app.module.global';
import { NombrecientificoListComponent } from './nombrescientificos/nombrecientifico-list.component';
import { NombrecientificoEditComponent } from './nombrescientificos/nombrecientifico-edit.component';
import { NombreCientificoService } from './nombrescientificos/nombrecientifico.service';
import { CodigoEppoListComponent } from './codigoseppo/codigoeppo-list.component';
import { CodigoEppoEditComponent } from './codigoseppo/codigoeppo-edit.component';
import { CodigoEppoService } from './codigoseppo/codigoeppo.service';
import { GrupoListComponent } from './gruposformas/grupo-list.component';
import { GrupoEditFormaListComponent } from './gruposformas/grupo-edit-forma-list.component';
import { FormaEditSubformaListComponent } from './gruposformas/forma-edit-subforma-list.component';
import { SubFormaEditComponent } from './gruposformas/subforma-edit.component';
import { GrupoFormaService } from './gruposformas/grupoforma.service';
import { EspeciesGruposFormasListComponent } from './especiesgruposformas/especiesgruposformas-list.component';
import { EspeciesGruposFormasEditComponent } from './especiesgruposformas/especiesgruposformas-edit.component';
import { EspeciesGruposFormasService } from './especiesgruposformas/especiesgruposformas.service';
import { PaginatorModule } from 'primeng/paginator';
import { VariedadEditComponent } from './variedades/variedad-edit/variedad-edit.component';
import { VariedadFilterComponent } from './variedades/variedad-filter/variedad-filter.component';
import { VariedadListComponent } from './variedades/variedad-list/variedad-list.component';
import { VariedadWrapperEditComponent } from './variedades/variedad-wrapper-edit/variedad-wrapper-edit.component';
import { VariedadWrapperComponent } from './variedades/variedad-wrapper/variedad-wrapper.component';
import { VariedadBuscadorComponent } from './variedades/variedad-buscador/variedad-buscador.component';
import { VariedadService } from './variedades/variedad.service';
import { RestriccionProductosExWrapperComponent } from './restriccionproductosex/restriccionproductoex-wrapper/restriccionproductoex-wrapper.component';
import { RestriccionProductosExFilterComponent } from './restriccionproductosex/restriccionproductoex-filter/restriccionproductoex-filter.component';
import { RestriccionProductosExListComponent } from './restriccionproductosex/restriccionproductoex-list/restriccionproductoex-list.component';
import { RestriccionProductosExWrapperEditComponent } from './restriccionproductosex/restriccionproductoex-wrapper-edit/restriccionproductoex-wrapper-edit.component';
import { RestriccionProductosExEditComponent } from './restriccionproductosex/restriccionproductoex-edit/restriccionproductoex-edit.component';
import { RestriccionProductosExService } from './restriccionproductosex/restriccionproductoex.service';
import { ComunesModule } from '../../_comunes/comunes.module';
import { EspeciesRoutingModule } from './especies-routing.module';
import { OrganismosNocivosWrapperComponent } from './organismosnocivos/organismosnocivos-wrapper/organismosnocivos-wrapper.component';
import { OrganismosNocivosFilterComponent } from './organismosnocivos/organismosnocivos-filter/organismosnocivos-filter.component';
import { OrganismosNocivosWrapperEditComponent } from './organismosnocivos/organismosnocivos-wrapper-edit/organismosnocivos-wrapper-edit.component';
import { OrganismosNocivosEditComponent } from './organismosnocivos/organismosnocivos-edit/organismosnocivos-edit.component';
import { OrganismosNocivosListComponent } from './organismosnocivos/organismosnocivos-list/organismosnocivos-list.component';
import { OrganismosNocivosService } from './organismosnocivos/organismosnocivos.service';
import { PanelProductosWrapperComponent } from './panelproductos/panelproductos-wrapper/panelproductos-wrapper.component';
import { PanelProductosFilterComponent } from './panelproductos/panelproductos-filter/panelproductos-filter.component';
import { PanelProductosListComponent } from './panelproductos/panelproductos-list/panelproductos-list.component';
import { PanelProductosService } from './panelproductos/panelproductos.service';
import { ConfiguracionTaricWrapperComponent } from './configuraciontaric/configuraciontaric-wrapper/configuraciontaric-wrapper.component';
import { ConfiguracionTaricFilterComponent } from './configuraciontaric/configuraciontaric-filter/configuraciontaric-filter.component';
import { ConfiguracionTaricListComponent } from './configuraciontaric/configuraciontaric-list/configuraciontaric-list.component';
import { ConfiguracionTaricWrapperEditComponent } from './configuraciontaric/configuraciontaric-wrapper-edit/configuraciontaric-wrapper-edit.component';
import { ConfiguracionTaricEditComponent } from './configuraciontaric/configuraciontaric-edit/configuraciontaric-edit.component';
import { ConfiguracionTaricService } from './configuraciontaric/configuraciontaric.service';

@NgModule({
    declarations: [
        NombrecientificoListComponent,
        NombrecientificoEditComponent,
        CodigoEppoListComponent,
        CodigoEppoEditComponent,
        GrupoListComponent,
        GrupoEditFormaListComponent,
        FormaEditSubformaListComponent,
        SubFormaEditComponent,
        EspeciesGruposFormasListComponent,
        EspeciesGruposFormasEditComponent,

        VariedadEditComponent,
        VariedadListComponent,
        VariedadFilterComponent,
        VariedadWrapperComponent,
        VariedadWrapperEditComponent,
        VariedadBuscadorComponent,

        RestriccionProductosExWrapperComponent,
        RestriccionProductosExFilterComponent,
        RestriccionProductosExListComponent,
        RestriccionProductosExWrapperEditComponent,
        RestriccionProductosExEditComponent,

        OrganismosNocivosWrapperComponent,
        OrganismosNocivosFilterComponent,
        OrganismosNocivosListComponent,
        OrganismosNocivosWrapperEditComponent,
        OrganismosNocivosEditComponent,

        PanelProductosWrapperComponent,
        PanelProductosFilterComponent,
        PanelProductosListComponent,

        ConfiguracionTaricWrapperComponent,
        ConfiguracionTaricFilterComponent,
        ConfiguracionTaricListComponent,
        ConfiguracionTaricWrapperEditComponent,
        ConfiguracionTaricEditComponent,
    ],
    imports: [CoreModule, AppModuleGlobalShared, PaginatorModule, CommonModule, FormsModule, ReactiveFormsModule, ComunesModule, EspeciesRoutingModule],
    providers: [
        NombreCientificoService,
        GrupoFormaService,
        CodigoEppoService,
        EspeciesGruposFormasService,
        VariedadService,
        RestriccionProductosExService,
        OrganismosNocivosService,
        PanelProductosService,
        ConfiguracionTaricService,
    ],
    exports: [VariedadBuscadorComponent, VariedadListComponent],
})
export class EspeciesModule {}
